import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function App() {
  const [projectCode, setProjectCode] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Attempt to fetch the JSON file that matches the project code
      const response = await fetch(`/data/projects/${projectCode}.json`);
      
      if (!response.ok) {
        throw new Error('Project not found');
      }

      const project = await response.json();
      navigate(`/project/${project.projectCode}`); // Redirect to the project page
    } catch (error) {
      alert('Project not found!');
      console.error('Error fetching project data:', error);
    }
  };

  return (
    <div className="App home-page">
      <header className="App-header">
        <h1>Entrez le code du projet</h1>
      </header>
      <main>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Entrez le code du projet"
            value={projectCode}
            onChange={(e) => setProjectCode(e.target.value)}
          />
          <button type="submit">Valider</button>
        </form>
      </main>
    </div>
  );
}

export default App;
